import { render, staticRenderFns } from "./WIPbanner.vue?vue&type=template&id=b0ccb90c&scoped=true&"
import script from "./WIPbanner.vue?vue&type=script&lang=js&"
export * from "./WIPbanner.vue?vue&type=script&lang=js&"
import style0 from "./WIPbanner.vue?vue&type=style&index=0&id=b0ccb90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ccb90c",
  null
  
)

export default component.exports